import CalendarioFuoriServizio from './components/CalendarioFuoriServizio'

export const routes = [
  {
    path: 'lavori-elettrici',
    sidebar: 'Lavori elettrici',
    main: () => <CalendarioFuoriServizio />,
  },
]
